import axios from '../../axios'

/*
 * 用户管理模块
 */

// 保存
// export const save = (data) => {
//     return axios({
//         url: '/system/sysAttach/save',
//         method: 'post',
//         data
//     })
// }
// 编辑
// export const edit = (data) => {
//     return axios({
//         url: '/system/sysAttach/edit',
//         method: 'post',
//         data
//     })
// }
// 查看
export const view = (data) => {
    return axios({
        url: '/system/sysAttach/view',
        method: 'post',
        data
    })
}
// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/system/sysAttach/delete',
        method: 'post',
        data
    })
}
// 分页查询
export const list = (data) => {
    return axios({
        url: '/system/sysAttach/list',
        method: 'post',
        data
    })
}
// 根据attachIds查询附件
export const getAttachByIds = (params) => {
    return axios({
        url: '/system/sysAttach/getAttachByIds',
        method: 'post',
        params
    })
}

// 下载
export const download = (data) => {
  if(!data.name){
    this.$message({message: '文件名不能为空！', type: 'error'})
  }
  return axios({
    url: '/system/sysAttach/download',
    method: 'post',
    data,
    responseType: 'blob'
  }).then(res => {
    console.log(res)
    if(res){
      openDownloadDialog(res,data.name)
    }
  })
}

function openDownloadDialog(url, saveName)
{
  if(typeof url == 'object' && url instanceof Blob)
  {
    url = URL.createObjectURL(url); // 创建blob地址
  }
  var aLink = document.createElement('a');
  aLink.href = url;
  aLink.download = saveName || ''; // HTML5新增的属性，指定保存文件名，可以不要后缀，注意，file:///模式下不会生效
  var event;
  if(window.MouseEvent) event = new MouseEvent('click');
  else
  {
    event = document.createEvent('MouseEvents');
    event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
  }
  aLink.dispatchEvent(event);
}



// WEBPACK FOOTER //
// ./src/http/moudules/sys/attach.js